import { styled } from "@mui/material/styles";
import Script from "next/script";

import type { ExternalWidgetBookingkit as ExternalWidgetBookingkitType } from "../../types/ExternalWidget";

type BookingkitProps = Omit<ExternalWidgetBookingkitType, "__typename">;

const StyledDiv = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 340,
});

export function Bookingkit({ widgetId, subdomain }: BookingkitProps) {
    const scriptSrc = subdomain ? new URL(`https://${subdomain}.widget.bookingkit.net/bkscript/${widgetId}`) : null;

    return (
        <>
            <StyledDiv id="bookingKitContainer" data-cw={widgetId}></StyledDiv>
            {scriptSrc ? <Script src={scriptSrc.toString()} /> : null}
        </>
    );
}
